<template>
  <div
    class="w-full text-sm"
    :class="{
      'text-secondary--1': isKids || isGuardian,
      'text-pets-tertiary-0': isPets
    }"
  >
    <slot />
  </div>
</template>

<script setup>
import { isKids, isGuardian, isPets } from '@/comp/AppType'
</script>
